import { Palette } from 'lucide-react'
import { lightMenuPresetDefaults, type ThemeConfig } from '@/types/theme'
import { getShellTintBackground } from '@/utils/shellTint'
import { ColorPickerField } from '@/components/Configuracao/AppearanceColorPickerField'

type Props = {
  draft: ThemeConfig
  onClearPreset: () => void
  updateDraft: (patch: Partial<ThemeConfig>) => void
}

export function AppearanceCoresDegradeSection({ draft, onClearPreset, updateDraft }: Props) {
  const degradeColor = draft.degradeColor ?? lightMenuPresetDefaults.degradeColor
  const degradePercent = draft.degradePercent ?? 0
  const bgSidebar = draft.bgSidebar ?? '#ffffff'

  return (
    <div className="glass-card p-5 space-y-4">
      <div>
        <h3 className="text-text-primary font-semibold text-sm flex items-center gap-2">
          <Palette size={14} className="text-accent" />
          Degradê — Menu e Supertopo
        </h3>
        <p className="text-text-muted text-[11px] mt-0.5">
          Lavanda suave sobre o fundo base do menu lateral e do supertopo. 0% = sem degradê.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ColorPickerField
          label="Cor do Degradê"
          value={degradeColor}
          onChange={(v) => {
            onClearPreset()
            updateDraft({ degradeColor: v })
          }}
        />
        <div className="flex flex-col gap-1.5">
          <label className="text-text-muted text-[11px] font-medium uppercase tracking-wider">
            Intensidade do Degradê ({degradePercent}%)
          </label>
          <input
            type="range"
            min={0}
            max={100}
            step={1}
            value={degradePercent}
            onChange={(e) => {
              onClearPreset()
              updateDraft({ degradePercent: Number(e.target.value) })
            }}
            className="w-full accent-accent"
          />
          <div className="flex items-center gap-2 mt-1">
            <div
              className="h-10 flex-1 rounded-lg border border-white/[0.08]"
              style={{
                backgroundColor: getShellTintBackground(degradeColor, degradePercent, bgSidebar),
              }}
            />
            <span className="text-[10px] text-text-muted font-mono shrink-0">
              {getShellTintBackground(degradeColor, degradePercent, bgSidebar)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
